import { motion } from "framer-motion";
import scrollToId from "../lib/scrollToId";
import { CURRENT_YEAR_SHORT } from "../lib/currentYear";

const links = [
  { label: "PROJECTS", id: "projects", testid: "nav-projects-link" },
  { label: "ABOUT", id: "about", testid: "nav-about-link" },
  { label: "CONNECT", id: "connect", testid: "nav-connect-link" },
];

export default function Nav() {
  return (
    <motion.header
      initial={{ y: -24, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: 1.2 }}
      className="fixed top-0 left-0 right-0 z-50 border-b border-white/5 bg-ink/70 backdrop-blur-xl"
      data-testid="main-nav"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-4 lg:px-10">
        <button
          data-testid="nav-logo"
          onClick={() => window.__lenis?.scrollTo(0, { duration: 1.4 })}
          className="font-mono text-sm font-medium tracking-[0.25em] text-white transition-colors duration-300 hover:text-accent"
        >
          DT<span className="text-accent">©</span>{CURRENT_YEAR_SHORT}
        </button>
        <nav className="hidden items-center gap-10 md:flex">
          {links.map((l) => (
            <button
              key={l.id}
              data-testid={l.testid}
              onClick={() => scrollToId(l.id)}
              className="group relative font-mono text-[11px] tracking-[0.25em] text-zinc-400 transition-colors duration-300 hover:text-white"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-px w-0 bg-accent transition-all duration-500 group-hover:w-full" />
            </button>
          ))}
        </nav>
        <button
          data-testid="nav-connect-mobile"
          onClick={() => scrollToId("connect")}
          className="font-mono text-[11px] tracking-[0.25em] text-zinc-400 transition-colors duration-300 hover:text-white md:hidden"
        >
          CONNECT
        </button>
      </div>
    </motion.header>
  );
}
